
namespace TabAurous.Common {

    @Serenity.Decorators.registerClass()
    export class PartySelectGrid extends _Ext.GridBase<OMS.AccountLedgerRow, any> {
        protected getColumnsKey() { return 'OMS.AccountLedger'; }
        protected getDialogType() { return OMS.AccountLedgerDialog; }
        protected getIdProperty() { return OMS.AccountLedgerRow.idProperty; }
        protected getLocalTextPrefix() { return OMS.AccountLedgerRow.localTextPrefix; }
        protected getService() { return OMS.PartySelectService.baseUrl; }

        constructor(container: JQuery, options) {
            super(container, options);
            var AccountGroupId = options.GridFilters.AccountGroupId;
            if (AccountGroupId != undefined && AccountGroupId > 0)
                (this.view.params as PartyRequest).AccountGroupId = AccountGroupId;
            this.slickGrid.setOptions({ rowHeight: 30 });
        }
        private autoSize;

        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize();
            grid.registerPlugin(this.autoSize);


            return grid;
        }


        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }
        updateInterface() {
            super.updateInterface();

            this.toolbar.findButton('add-button').toggle(false);
        }
    }
}